import { useEffect } from 'react';

import {
	AkselLocale,
	Textarea,
	TextField as AkselTextField,
} from 'components/form/aksel';
import { useForm } from 'components/form/Form';

export default function TextField(props) {
	const {
		name,
		label = '',
		description,
		disabled,
		tooltip,
		defaultValue,
		style,
		multiline = false,
		rows = undefined,
		maxRows = undefined,
		onChange,
		...rest
	} = props;

	const { registerField, updateField, isDisabled, values, errors } =
		useForm();

	const error = errors[name];

	useEffect(() => {
		registerField(props);
	});

	const help = [description, tooltip].filter(Boolean).join(' ');

	const shared = {
		name,
		label,
		disabled: disabled || isDisabled,
		defaultValue: defaultValue || values[name],
		...(help === '' ? {} : { description: help }),
		...(error
			? {
					error:
						typeof error === 'string'
							? error
							: 'Dette feltet er påkrevd',
				}
			: {}),
		onChange: event => {
			updateField({ name, value: event.target.value.trim() });
			onChange && onChange(event);
		},
	};

	return (
		<AkselLocale>
			<div className="mb-4" style={style}>
				{multiline ? (
					<Textarea
						{...shared}
						{...(rows === undefined
							? {}
							: { minRows: Number(rows) })}
						{...(maxRows === undefined
							? {}
							: { maxRows: Number(maxRows) })}
						{...rest}
					/>
				) : (
					<AkselTextField {...shared} {...rest} />
				)}
			</div>
		</AkselLocale>
	);
}
